import type { DalError, DalReturn } from "@/core/dal/data.type";
import { dalDbOperation } from "@/core/dal/helper";
import type { AirportSearchData } from "@/core/schemas/airport.schema";
import type ApiService from "@/core/services/api.service";
import type APIEndpointsService from "@/core/services/api-endpoints.service";
import type { Airport } from "@/core/types/airport.type";
import type { CollectionResponse } from "@/core/types/collection.type";

class AirportsService {
	constructor(
		private apiService: ApiService,
		private apiEndpointsService: APIEndpointsService,
	) {}

	getAirports(
		data: AirportSearchData | { q: string },
		signal?: AbortSignal,
	): Promise<DalReturn<CollectionResponse<Airport>, DalError>> {
		return dalDbOperation(() =>
			this.apiService.get<CollectionResponse<Airport>>(
				this.apiEndpointsService.getRoutes().airports.get(),
				data,
				signal,
			),
		);
	}

	getAirportById(id: string): Promise<DalReturn<Airport, DalError>> {
		return dalDbOperation(() =>
			this.apiService.get<Airport>(
				this.apiEndpointsService.getRoutes().airports.get(id),
			),
		);
	}
}

export default AirportsService;
